import { FetchMFAPreferenceOutput } from 'aws-amplify/auth';
import { useQuery } from '@tanstack/react-query';

export type MfaStatus = FetchMFAPreferenceOutput;

/**
 * In the iframe context, MFA has already been verified by the shell before
 * the user reaches us. Return a stub indicating TOTP is enabled so that
 * the app never tries to redirect to MFA setup.
 */
export const useMfaPreferenceQuery = (_username?: string) => {
	return useQuery({
		queryKey: ['mfaPreference', _username],
		queryFn: async (): Promise<FetchMFAPreferenceOutput> => ({
			enabled: ['TOTP'],
			preferred: 'TOTP'
		})
	});
};
